import { Time } from '@angular/common';

export class projekt {



  constructor() {
  }



  public pId: string = '';
  public ProjectId: string = '';
  public Type: string = '';
  public ProjectName: string = '';
  public Topic: string = '';
  public Responsible: string = '';
  public LinkResponsible: string = '';
  public StrategyFocus: string = '';
  public LinkProject: string = '';
  public StartDate: Date;
  public EndDate: Date;
  public ProjectDescription: string = '';

  public Category: string = '';
  public SelectionCriteria: string = '';
  public InterregPeriod: string = '';
  public AidAmount: string = '0';
  public Applicant: string = '';
  public ApplicantStatus: string = '';
  public ApplicantRegion: string = '';
  public ApplicantLink: string = '';

  public Partner1: string = "";
  public Partner1Region: string = "";
  public Partner1Link: string = "";
  public Partner2: string = "";
  public Partner2Region: string = "";
  public Partner2Link: string = "";
  public Partner3: string = "";
  public Partner3Region: string = "";
  public Partner3Link: string = "";

}

export class projectFiles {

  constructor() {

  }

  public fId: string = '';
  public pId: string = '';
  public Filename: string = '';
  public Filesize: string = '';
  public ContentType: string = '';
  public Pos: string = '';
  public ProjectImage: string = "";
}

export class projectLink {
   
  constructor() {

  }

  public lId: string = '';
  public pId: string = '';
  public Linkname: string = '';
  public URL: string = '';
  public Pos: string = '';
  public PartnerRegion: string;

}

export class projectVideo {

  constructor() {

  }

  public vId: string = '';
  public pId: string = '';
  public Pos: number;
  public Name: string = '';
  public EmbedCode: string = '';

}

export enum ProjectType {
  IBK = "ibk",
  KP = "kp"
}
